const state = {
  previous_school_name: null,
  previous_school_address: null,
  previous_school_dates: null,
  previous_school_type: null,
  previous_school_type_other_field: null,
  is_previous_student_of_mpsaz: null,
  previous_grade_and_year: null,
  has_read_SDS: null,
  has_been_in_special_classes: null,
  special_classes: [],
  has_been_in_special_ed: null,
  has_been_in_ED: null,
  has_been_in_autism_classes: null,
  has_been_in_SLD: null,
  has_been_in_MIID: null,
  has_been_in_MOID: null,
  has_been_in_SID: null,
  has_been_in_OT: null,
  has_been_in_SLI: null,
  has_been_in_other_special_ED_classes: null,
  other_special_ED_classes: null,
  has_current_IEP: null,
  has_current_MET_report: null,
  has_504_plan: null,
  has_custody_agreement: null,
  has_letters_of_guardianship: null,
  has_power_of_attorney: null,
  is_not_living_with_bio_parents: null,
  has_injunction: null,
  has_order_of_protection: null,
  is_covered_by_order: null,
  has_been_suspended: null,
  suspended_dates: null,
  has_been_expelled: null,
  expulsion_dates: null,
  has_suspension_or_expulsion_been_recommended: null,
  recommendation_dates: null,
  school_suspended_or_expelled_from: null,
  length_of_expulsion_suspension: null,
  specific_number_of_days: null,
  reason_for_suspension_expulsion: null,
  has_been_revoked: null,
  has_ever_been_in_correctional_facility: null,
  transportation_type: null,
  is_wanting_info_about_lunch_program: null,
  is_american_indian: null,
  lives_in: null,
  US_tribal_number: null,
  selected_transportation: [],
  selected_special_ED: []

}

const mutations = {
  setPreviousSchoolName(state, value) {
    state.previous_school_name = value;
  },
  setPreviousSchoolAddress(state, value) {
    state.previous_school_address = value;
  },
  setPreviousSchoolDates(state, value) {
    state.previous_school_dates = value;
  },
  setPreviousSchoolType(state, value) {
    state.previous_school_type = value;
    if (state.previous_school_type !== 'other')
      state.previous_school_type_other_field = null;
  },
  setPreviousSchoolTypeOtherField(state, value) {
    state.previous_school_type_other_field = value;
  },
  setPreviousStudentOfMPSAZ(state, value) {
    state.is_previous_student_of_mpsaz = value;
    if (state.is_previous_student_of_mpsaz === false) {
      state.previous_grade_and_year = null;
    }
  },
  setPreviousGradeAndYear(state, value) {
    state.previous_grade_and_year = value;
  },
  setHasReadSDS(state, value) {
    state.has_read_SDS = value;
  },
  setHasBeenInSpecialClasses(state, value) {
    state.has_been_in_special_classes = value;
    if (state.has_been_in_special_classes === false) {
      while (state.special_classes.length) {
        state.special_classes.pop();
      }
    }
  },
  setSpecialClasses(state, value) {
    state.special_classes = value;
  },
  setHasBeenInSpecial_Ed(state, value) {
    state.has_been_in_special_ed = value;
  },
  setHasBeenInED(state, value) {
    state.has_been_in_ED = value;
  },
  setHasBeenInAutismClasses(state, value) {
    state.has_been_in_autism_classes = value;
  },
  setHasBeenInSLD(state, value) {
    state.has_been_in_SLD = value;
  },
  setHasBeenInMIID(state, value) {
    state.has_been_in_MIID = value;
  },
  setHasBeenInMOID(state, value) {
    state.has_been_in_MOID = value;
  },
  setHasBeenInSID(state, value) {
    state.has_been_in_SID = value;
  },
  setHasBeenInOT(state, value) {
    state.has_been_in_OT = value;
  },
  setHasBeenInSLI(state, value) {
    state.has_been_in_SLI = value;
  },
  setHasBeenInOtherSEClasses(state, value) {
    state.has_been_in_other_special_ED_classes = value;
  },
  setOtherSpecialEdClasses(state, value) {
    state.other_special_ED_classes = value;
  },
  setHasCurrentIEP(state, value) {
    state.has_current_IEP = value;
  },
  setHasCurrentMET(state, value) {
    state.has_current_MET_report = value;
  },
  setHasCurrent504(state, value) {
    state.has_504_plan = value;
  },
  setHasCustodyAgreement(state, value) {
    state.has_custody_agreement = value;
  },
  setHasLettersOfGuardianship(state, value) {
    state.has_letters_of_guardianship = value;
  },
  setHasPowerOfAttorney(state, value) {
    state.has_power_of_attorney = value;
  },
  setIsNotLivingWithBioParents(state, value) {
    state.is_not_living_with_bio_parents = value;
  },
  setHasInjunction(state, value) {
    state.has_injunction = value;
  },
  setHasOrderOfProtection(state, value) {
    state.has_order_of_protection = value;
  },
  setIsCoveredByOrder(state, value) {
    state.is_covered_by_order = value;
  },
  setHasBeenSuspended(state, value) {
    state.has_been_suspended = value;
    if (state.has_been_suspended === false) {
      state.suspended_dates = null;
    }
  },
  setSuspendedDates(state, value) {
    state.suspended_dates = value;
  },
  setHasBeenExpelled(state, value) {
    state.has_been_expelled = value;
  },
  setExpulsionDates(state, value) {
    state.expulsion_dates = value;
  },
  setHasSuspensionExpulsionBeenRecommended(state, value) {
    state.has_suspension_or_expulsion_been_recommended = value;
  },
  setRecommendationDates(state, value) {
    state.recommendation_dates = value;
  },
  setSchoolSuspendedOrExpelledFrom(state, value) {
    state.school_suspended_or_expelled_from = value;
  },
  setLengthOfSuspension(state, value) {
    state.length_of_expulsion_suspension = value;
  },
  setSpecificNumberOfDays(state, value) {
    state.specific_number_of_days = value;
  },
  setReasonForSuspensionExpulsion(state, value) {
    state.reason_for_suspension_expulsion = value;
  },
  setHasBeenRevoked(state, value) {
    state.has_been_revoked = value;
  },
  setHasBeenInCorrectionalFacility(state, value) {
    state.has_ever_been_in_correctional_facility = value;
  },
  setTransportationType(state, value) {
    state.transportation_type = value;
  },
  setIsWantingInfoAboutLunchProgram(state, value) {
    state.is_wanting_info_about_lunch_program = value;
  },
  setIsAmericanIndian(state, value) {
    state.is_american_indian = value;
  },
  setLivesIn(state, value) {
    state.lives_in = value;
  },
  setUS_tribal_number(state, value) {
    state.US_tribal_number = value;
  },
  setSelectedTransportation(state, value) {
    state.selected_transportation = value
    if (!state.selected_transportation.includes('Other'))
      state.transportation_type = null;
  },
  setSelectedSpecialED(state, value) {
    state.selected_special_ED = value;
    if (!state.selected_special_ED.includes('Other'))
      state.other_special_ED_classes = null;
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
